import axios from "axios";
import { isTokenExpired } from "../utils/isTokenExpired";

// const token = localStorage.getItem("token");

const instance = axios.create({
    // baseURL: "https://dev.risk-api.africacodefoundry.com/", // dev server
  // baseURL: "https://risk-api.africacodefoundry.com/", //pro
  // baseURL: "http://localhost:3001/",
  baseURL: process.env.REACT_APP_API_URL || "https://risk-api.africacodefoundry.com/",
  // baseURL: "https://dev.risk-api.africacodefoundry.com/", // dev server
  // baseURL: "https://risk-api.africacodefoundry.com/", //pro
  headers: {
    "Content-Type": "application/json",
    // Authorization: `Bearer ${token}`,
    Accept: "application/json",
    // "Access-Control-Allow-Origin": "*",
  },
  withCredentials: true
});

instance.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem("token"); // always get fresh token

    if (token && isTokenExpired(token)) {
      localStorage.clear();
      window.location.href = "/login";
      return Promise.reject(new Error("Token expired"));
    }

    if (token) {
      config.headers.Authorization = `Bearer ${token}` 
    }
    
    // Add tenant domain header for multi-tenancy.
    // On localhost, use the same REACT_APP_DEV_TENANT_DOMAIN override as configLoader so branding and API data match.
    const hostname = window.location.hostname;
    const isLocal = hostname === 'localhost' || hostname === '127.0.0.1';
    config.headers['X-Tenant-Domain'] = isLocal && process.env.REACT_APP_DEV_TENANT_DOMAIN
      ? process.env.REACT_APP_DEV_TENANT_DOMAIN
      : hostname;
    
    return config;
  },
  (error) => Promise.reject(error)
)

instance.interceptors.response.use(
  (response) => {
    return response;
  },
  (error) => {
    if (error.response?.status === 401) {
      localStorage.clear();
      window.location.href = "/login";
    }
    return Promise.reject(error); // Reject to propagate the error
  }
);

export const fetchEntryDueDate = async () => {
  let dueDate;
  try {
    const response = await instance.get(
      "/api/admin/riskDuedate/riskDuedates/status/UNDER_REVIEW"
    );
    if (response.data && response.data.data && response.data.data.dueDate) {
      dueDate = new Date(response.data.data.dueDate);
    } else {
      return
    }
  } catch (error) {
    if (error.response || error.response?.data?.statusCode === 404 || error.response?.status === 404) {
      return null;
    }
    console.error("Error fetching due date: ", error);
    return;
  }
  return dueDate;
};

export const fetchRatingDueDate = async () => {
  let dueDate;
  try {
    const response = await instance.get(
      "/api/admin/riskDuedate/riskDuedates/status/ASSESSMENT_IN_PROGRESS"
    );
    dueDate = new Date(response.data.data.dueDate);
  } catch (error) {
    if (error.response && error.response.data.statusCode === 404) {
      return null;
    }
    return;
  }
  return dueDate;
};

export const fetchAssessmentDueDate = async () => {
  let dueDate;
  try {
    const response = await instance.get(
      "/api/admin/riskDuedate/riskDuedates/status/APPROVED_FOR_ACTION"
    );
    dueDate = new Date(response.data.data.dueDate);
  } catch (error) {
    if (error.response && error.response.data.statusCode === 404) {
      return null;
    }
    return;
  }
  return dueDate;
};

export const fetchInitialResponseDueDate = async () => {
  let dueDate;
  try {
    const response = await instance.get(
      "/api/admin/riskDuedate/riskDuedates/status/ASSESSMENT_COMPLETED"
    );
    dueDate = new Date(response.data.data.dueDate);
  } catch (error) {
    if (error.response && error.response.data.statusCode === 404) {
      return null;
    }
    return;
  }
  return dueDate;
};

export const fetchResponseRatingDueDate = async () => {
  let dueDate;
  try {
    const response = await instance.get(
      "/api/admin/riskDuedate/riskDuedates/status/PLAN_UNDER_REVIEW"
    );
    dueDate = new Date(response.data.data.dueDate);
  } catch (error) {
    if (error.response && error.response.data.statusCode === 404) {
      return null;
    }
    return;
  }
  return dueDate;
};

export const fetchAllDepartments = async () => {
  let departments = [];
  try {
    const response = await instance.get("/api/departments/all");
    departments = response.data.data;
  } catch (error) {
    if (error.response && error.response.data.statusCode === 404) {
      return null;
    }
    return;
  }
  return departments;
};

export default instance;
